// Native details keeps service links usable without JavaScript.
document.querySelectorAll('[data-service-disclosure]').forEach(disclosure => {
  const desktopDisclosure = disclosure.closest('.desktop-nav');
  const summary = disclosure.querySelector('summary');
  let closeTimer;
  const cancelClose = () => {
    clearTimeout(closeTimer);
    closeTimer = undefined;
  };
  const scheduleClose = () => {
    cancelClose();
    closeTimer = setTimeout(() => { disclosure.open = false; }, 250);
  };
  if (desktopDisclosure) {
    disclosure.addEventListener('pointerenter', () => { cancelClose(); disclosure.open = true; });
    disclosure.addEventListener('pointerleave', scheduleClose);
    disclosure.addEventListener('focusin', () => { cancelClose(); disclosure.open = true; });
    summary.addEventListener('click', event => {
      // Hover already opened the desktop menu; a pointer click should not
      // immediately close it. Keyboard activation retains native details use.
      if (event.detail > 0 && disclosure.open) event.preventDefault();
    });
  }
  disclosure.addEventListener('keydown', event => {
    if (event.key === 'Escape' && disclosure.open) {
      event.stopPropagation();
      cancelClose();
      disclosure.open = false;
      summary.focus();
    }
  });
  document.addEventListener('click', event => {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  });
  disclosure.addEventListener('focusout', event => {
    if (event.relatedTarget && !disclosure.contains(event.relatedTarget)) scheduleClose();
  });
});

// Electronic withdrawal function and the model withdrawal form. The merchant's
// brief requires a withdrawal the customer can click and send, so the entered
// values are composed into the message body of the notification email. The
// labels come from data-label / data-value-label on each field so the same code
// serves both forms and follows the active locale. Without JavaScript every
// field still posts; only the readable summary and the conditional requirement
// for the item list are enhancements.
document.querySelectorAll('form.withdrawal-form').forEach(form => {
  const body = form.querySelector('[data-withdrawal-body]');
  const items = form.querySelector('[data-withdrawal-items]');
  const partial = form.querySelector('[data-withdrawal-scope-partial]');
  if (!body) return;
  const base = body.value;
  const compose = () => {
    const lines = [base];
    form.querySelectorAll('[data-label]').forEach(field => {
      const label = field.dataset.label;
      const type = (field.type || '').toLowerCase();
      if (!label) return;
      if (type === 'radio') {
        if (field.checked) lines.push(`${label}: ${field.value}`);
        return;
      }
      if (type === 'checkbox') {
        if (field.checked) lines.push(`${label}: ${field.dataset.valueLabel || field.value}`);
        return;
      }
      const value = (field.value || '').trim();
      if (value) lines.push(`${label}: ${value}`);
    });
    body.value = lines.join('\n');
  };
  const syncRequired = () => {
    if (!items || !partial) return;
    items.required = partial.checked;
  };
  // Only the date of the declaration defaults to today. "Ordered on" and
  // "received on" are facts the customer has to supply, so they stay empty.
  const today = new Date();
  const iso = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  form.querySelectorAll('[data-today-default]').forEach(field => { if (!field.value) field.value = iso; });
  form.addEventListener('input', () => { compose(); syncRequired(); });
  form.addEventListener('change', () => { compose(); syncRequired(); });
  syncRequired();
  compose();
});
